import { ENABLE_ACTIONS, GIS, SET_HAS_POLYGON } from "../actions/map.actions"

const initialState = {
    actions: false,
    gis: null,
    hasPolygon: false,
}

export const mapReducer = (state = initialState, action) => {
    switch(action.type) {
        case ENABLE_ACTIONS:
            return {...state, actions: true};
        case GIS:
            return { ...state, gis: action.payload };
        case SET_HAS_POLYGON:
            return { ...state, hasPolygon: action.payload };
        default:
            return state;
    }
}